<template>
    <form method="get" action="/groepen">
        <div class="row row--fields">
            <div class="column">
                <div class="headersearch__title h5">Vind een groep of initiatief</div>
            </div>
        </div>
        <div class="row row--fields">
            <div class="column small-24">
                <div class="formfield input input--zip">
                    <LocationSearch name="locatie" />
                </div>
            </div>
        </div>
        <div class="row row--fields">
            <div class="column">
                <div class="formfield">
                    <div class="customselect">
                        <select name="filter">
                            <option value="1" v-for="item in selectItems" :value="item.value">{{ item.key }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="column">
                <div class="btn__headersearch">
                    <button class="btn">Zoeken in aanbod <i class="icon-arrow-right"></i></button>
                </div>
            </div>
        </div> 
    </form>
</template>

<script>
    import LocationSearch from '@/components/LocationSearch.vue';
    import axios from 'axios';

    export default {
        components: {
            LocationSearch
        },
        data() {
            return {
                selectItems: []
            }
        },
        mounted() {
            axios.get('/_group_categories', {
                type: 'groep'
            })
                .then((response) => {
                    this.selectItems = response.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        }
    }
</script>
